import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithDecryption } from "../baseQueryWithEncryption";

const companyApi = createApi({
  reducerPath: "companyApi",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_COMPANY_API_URL),
  tagTypes: ["Company", "assignedTeams"],
  endpoints: (build) => ({
    getCompany: build.query({
      query: () => "company",
      providesTags: ["Company"],
    }),
    updateCompany: build.mutation({
      query: (data) => ({
        url: `company`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    getAssignedTeams: build.query({
      query: () => "/assigned-team",
      providesTags: ["assignedTeams"],
    }),
    getCompanyDetails: build.query({
      query: () => "companyMgmt-details",
      providesTags: ["Company"],
    }),
    getAttachmentUrl: build.mutation({
      query: (body) => ({
        url: `/file/url`,
        body: body,
        method: "POST",
      }),
    }),
    updateTeam: build.mutation({
      query: ({ body }) => ({
        url: `/user-mgmt/user/teams`,
        method: "PATCH",
        body: body,
      }),
    }),
  }),
});

export const {
  useGetCompanyQuery,
  useUpdateCompanyMutation,
  useGetAssignedTeamsQuery,
  useGetCompanyDetailsQuery,
  useGetAttachmentUrlMutation,
  useUpdateTeamMutation,
} = companyApi;
export default companyApi;
